// extracted by mini-css-extract-plugin
export var divider = "_mh-0";
export var systemMessage = "_mh-1";
export var systemMessageWrapper = "_mh-2";